<template>
  <div class="dashboard">
    <div class="main-content">
      <navbar-dashboard name="Mi Cuenta" />

      <div class="ew-view">
        <div class="ew-form-page">
          <page-header title="Mi cuenta" subtitle="Tus datos de contacto dentro de SackTech."></page-header>

          <div class="ew-section ew-profile">
            <span class="ew-profile-avatar">{{ initials }}</span>
            <div style="min-width: 0;">
              <div class="ew-profile-name">{{ fullName || 'Tu perfil' }}</div>
              <div class="ew-profile-email">{{ user.email | dash }}</div>
            </div>
            <span v-if="roleLabel" class="badge badge-primary ml-auto">{{ roleLabel }}</span>
          </div>

          <form @submit.prevent="updateMiCuenta">
            <div class="ew-section">
              <h2 class="ew-section-title"><i class="bi bi-person text-primary"></i> Información personal</h2>
              <p class="ew-section-subtitle">Así te identificamos en guías, correos y notificaciones.</p>
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label for="firstName">Nombre</label>
                  <input id="firstName" type="text" class="form-control" v-model="user.firstName" autocomplete="given-name" />
                </div>
                <div class="col-md-6 form-group">
                  <label for="lastName">Apellidos</label>
                  <input id="lastName" type="text" class="form-control" v-model="user.lastName" autocomplete="family-name" />
                </div>
              </div>
            </div>

            <div class="ew-section">
              <h2 class="ew-section-title"><i class="bi bi-envelope text-primary"></i> Contacto</h2>
              <p class="ew-section-subtitle">El correo también es tu usuario para iniciar sesión.</p>
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label for="email">Correo electrónico</label>
                  <input id="email" type="email" class="form-control" v-model="user.email" autocomplete="email" />
                </div>
                <div class="col-md-6 form-group">
                  <label for="phone">Teléfono</label>
                  <input id="phone" type="tel" class="form-control" v-model="user.phone" autocomplete="tel"
                    placeholder="10 dígitos" />
                </div>
                <div class="col-md-6 form-group">
                  <label for="address">Dirección</label>
                  <input id="address" type="text" class="form-control" v-model="user.address" autocomplete="street-address" />
                </div>
                <div class="col-md-6 form-group">
                  <label for="website">Sitio web</label>
                  <input id="website" type="text" class="form-control" v-model="user.website" placeholder="www.tuempresa.com" />
                </div>
              </div>
            </div>

            <div class="ew-form-actions">
              <button type="submit" class="btn btn-primary" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                {{ loading ? 'Guardando…' : 'Guardar cambios' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import commons from "../commons";
import Navbar from "./Header/Navbar";

export default {
  components: { "navbar-dashboard": Navbar },
  data() {
    return {
      userId: localStorage.getItem("ew-user-id"),
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        website: "",
      },
      loading: false,
      success: false,
      role: localStorage.getItem("ew-user-role"),
    };
  },
  computed: {
    fullName() {
      return [this.user.firstName, this.user.lastName].filter(Boolean).join(" ");
    },
    initials() {
      const a = (this.user.firstName || "").trim().charAt(0);
      const b = (this.user.lastName || "").trim().charAt(0);
      return ((a + b) || (this.user.email || "?").charAt(0)).toUpperCase();
    },
    roleLabel() {
      const labels = {
        superadmin: "Superadmin",
        helpdesk: "Servicio al cliente",
        sales: "Ventas",
        client: "Administrador",
        user: "Operativo",
        admin: "Compras / Administración",
        admin_add: "Administrador adicional",
      };
      return labels[this.role] || "";
    },
  },
  mounted() {
    this.fetchMiCuenta();
  },
  methods: {
    async fetchMiCuenta() {
      try {
        const res = await axios.get(`${commons.apiURL}/api/v1/mi-cuenta/${this.userId}`);
        this.user = res.data;
      } catch (err) {
        console.error("Error al obtener la cuenta:", err);
      }
    },
    async updateMiCuenta() {
      this.loading = true;
      this.success = false;
      try {
        await axios.put(`${commons.apiURL}/api/v1/mi-cuenta/${this.userId}`, this.user);
        this.success = true;
        this.$bvToast.toast("Tus datos se guardaron correctamente.", {
          title: "Cambios guardados", variant: "success", solid: true, autoHideDelay: 3500,
        });
      } catch (err) {
        console.error("Error al actualizar cuenta:", err);
        this.$bvToast.toast("No pudimos guardar tus datos. Inténtalo de nuevo.", {
          title: "Error al guardar", variant: "danger", solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MiCuenta.vue